<template>
  <div class="login">
    <div class="main">
      <!-- 登录窗口 -->
      <div v-show="Isshow" class="login-box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="密码登录" name="first">
            <el-input v-model="input1" maxlength="11" placeholder="请输入手机号"></el-input>
            <el-input
              v-model="input2"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="loginAccount"
            ></el-input>
            <div class="codeVerify">
              <el-input v-model="captchaCode" placeholder="请输入验证码" maxlength="4"></el-input>
              <img
                v-if="captchaImage"
                class="captcha-img"
                :src="captchaImage"
                alt="验证码"
                @click="refreshCaptcha"
              />
              <img v-else style="margin-top: 2px;" :src="checkcodeImg" @click="refreshCaptcha" />
            </div>
            <div class="newBtn">
              <span @click="forgetbox()">忘记密码</span>
            </div>
            <div class="loginBtn" @click="loginAccount">登 录</div>
          </el-tab-pane>
          <el-tab-pane label="短信登录" name="second">
            <el-input v-model="input3" maxlength="11" placeholder="请输入手机号">
              <template slot="prepend">+86</template>
            </el-input>
            <div class="flex-item">
              <el-input
                v-model="input4"
                maxlength="6"
                placeholder="请输入验证码"
                @keyup.enter.native="loginVerifyCode"
              ></el-input>
              <el-button class="yzmBtn" type="primary" :disabled="disabled" @click="verifyCode">{{
                btntxt
              }}</el-button>
            </div>
            <div class="newBtn">
              <span @click="forgetbox()">忘记密码</span>
            </div>
            <div class="loginBtn" @click="loginVerifyCode">登 录</div>
          </el-tab-pane>
          <!-- <div class="other-item">
            <el-divider>其他方式登录</el-divider>
            <div class="icon-item">
              <div class="wechat-icon">
                <img src="@/assets/login/wechat_icon.png" alt="" />
              </div>
            </div>
          </div> -->
        </el-tabs>
        <div class="agreement">
          <el-checkbox v-model="agreed"></el-checkbox>
          <span class="agreement-text"
            >我已阅读并同意<span class="agreement-link" @click="showPrivacy = true"
              >《隐私协议》</span
            >和<span class="agreement-link" @click="showAgreement = true">《使用协议》</span></span
          >
        </div>
      </div>
      <!-- 忘记密码窗口 -->
      <div v-show="IsForget" class="regist-box">
        <span class="title">重置密码</span>
        <el-input v-model="forgetPhone" placeholder="请输入11位手机号">
          <template slot="prepend">+86</template>
        </el-input>
        <div class="flex-item">
          <el-input v-model="forgetCode" maxlength="6" placeholder="请输入验证码"></el-input>
          <el-button class="yzmBtn" type="primary" :disabled="disabled2" @click="sendForgetCode">{{
            btntxt2
          }}</el-button>
        </div>
        <el-input v-model="newPassword" placeholder="请输入新密码" show-password></el-input>
        <el-input
          v-model="confirmNewPassword"
          placeholder="请再次输入新密码"
          show-password
        ></el-input>
        <div class="loginBtn" @click="resetPassword">确 认</div>
        <p class="tip" @click="loginbox">返回登录</p>
      </div>
    </div>
    <div class="copyright">Copyright © 黄石市人才市场信息化平台</div>
    <!-- 隐私协议弹窗 -->
    <el-dialog
      title="隐私协议"
      :visible.sync="showPrivacy"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <div class="agreement-content">
        <p>
          黄石市人才市场信息化平台非常重视对您的隐私与信息保护，有时候我们需要某些信息才能为您提供您请求的服务，本隐私协议解释了这些情况下的数据收集和使用情况。
        </p>
        <p>
          本协议涉及黄石市人才市场信息化平台。除非您已阅读并接受本协议关于某运用场景的所有条款，否则您无权使用黄石市人才市场信息化平台相应场景服务。您对场景服务的登录、查看、发布信息等行为即视为您已阅读本协议，并同意本协议相关内容的约束。
        </p>
        <h2>（一）协议范围</h2>
        <p>
          1、本协议由同意并承诺遵守本协议规定，使用黄石市人才市场信息化平台服务的法律实体（下称"您"）与平台运营方共同缔结。本协议具有合同效力。
        </p>
        <p>
          2、本协议内容包括协议正文及所有运营方已经发布或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。
        </p>
        <p>
          3、您在使用平台提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。运营方有权根据需要不时制定、修改本协议或各类规则，如本协议有任何变更，运营方将在网站上以公示的形式通知您。
        </p>
        <h2>（二）我们收集哪些信息</h2>
        <p>
          通常，您能在匿名的状态下访问黄石市人才市场信息化平台并获取信息。当我们需要能识别您的特定信息与资料时，我们会征求您的同意。通常，在您注册用户或申请开通新的功能时，我们可能会按政府相关部门要求收集这些信息或证明材料：组织社会信用代码、营业执照、申请人姓名、身份证和人脸信息等，并征求您的确认。同时，为更好为您提供服务，您在平台上的活动信息以及上传的相关信息也将进行保留。
        </p>
        <h2>（三）保护您的隐私信息</h2>
        <p>
          黄石市人才市场信息化平台会严格保护您信息的安全。平台使用包含防病毒等安全防护功能，安全技术和程序来保护您的信息不会在未经授权的情况下被访问、使用或泄露。
        </p>
        <p>
          平台会一直保护您的隐私与信息安全，除非平台在经过诚信谨慎的权衡的基础上，认为透露这些信息是必要的，包括但不限于以下情况：
        </p>
        <p>（1）遵守有关法律规定，在国家有关机关查询时，提供您在平台产品上的相关信息。</p>
        <p>（2）为了遵从平台产品服务程序。</p>
        <p>（3）为维护平台的商标所有权。</p>
        <p>（4）在紧急情况下为维护用户个人和社会大众的权益。</p>
        <p>（5）在国家有关机构查询下。</p>
        <p>（6）平台认为必要的其他情况下。</p>
        <h2>（四）未成年人信息保护</h2>
        <p>
          我们非常重视未成年人的个人信息保护，未成年人对本服务的注册与使用应获得其监护人的同意。我们将依据国家相关法律法规规定保护未成年人的信息的保密性与安全性。
        </p>
        <h2>（五）如何联系我们</h2>
        <p>您可以通过以下方式与我们联系，我们将在15天内回复您的请求：</p>
        <p>（1）如对本政策内容有任何疑问、意见或建议，您可通过平台客服与我们联系；</p>
        <p>（2）如发现个人信息可能被泄露，您可以通过平台客服投诉举报。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showPrivacy = false">确定我已阅读</el-button>
      </span>
    </el-dialog>
    <!-- 使用协议弹窗 -->
    <el-dialog
      title="使用协议"
      :visible.sync="showAgreement"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <div class="agreement-content">
        <h1>欢迎您使用黄石市人才市场信息化平台服务！</h1>
        <p>
          为了更好的使用黄石市人才市场信息化平台平台服务，明确双方的权利义务，您应当仔细阅读《黄石市人才市场信息化平台服务协议》（以下简称"本协议"）以及专项规则等。请您务必审慎阅读、充分理解各条款内容，特别是责任条款、免责条款和限制条款。
        </p>
        <h2>一、协议的范围</h2>
        <p>
          1、本协议由同意并承诺遵守本协议规定，使用黄石市人才市场信息化平台服务的法律实体（下称"您"）与平台运营方共同缔结，本协议具有合同效力。
        </p>
        <p>
          2、本协议内容包括协议正文及所有运营方已经发布或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。
        </p>
        <p>
          3、您在使用运营方提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。运营方有权根据需要不时制定、修改本协议或各类规则。
        </p>
        <h2>二、关于本服务</h2>
        <p>1、您可以通过试用与购买获得平台服务；</p>
        <p>2、通过平台服务，您将获得基于平台的相关使用权；</p>
        <p>
          3、您可以将平台作为线上学习空间，组织员工进行线上学习，并对学习空间的名称、组织、内容等进行自定义建设；
        </p>
        <p>4、平台为您提供部分免费课程，同时您可以购买付费课程，最后您还可以上传自己录制的课程。</p>
        <h2>三、平台使用规则</h2>
        <p>1、用户的帐号、密码和安全性</p>
        <p>
          您一旦注册成功成为平台用户，您将得到密码和帐号。如果您未保管好自己的账号和密码而对平台或第三方造成的损害，您将承担相应责任。每个用户都要对其帐户中的所有活动和事件负责。
        </p>
        <p>2、平台使用规则：</p>
        <p>（1）严禁有任何违反现行法律法规的行为；</p>
        <p>（2）严禁侵害他人的著作权、知识产权，商业机密或隐私权等他人合法权利；</p>
        <p>（3）严禁利用本平台发布、传送、分发、储存危害国家安全、国家统一、社会安定的信息；</p>
        <p>
          （4）严禁利用本平台发布、传送、分发、储存属于诽谤、淫秽、威胁、辱骂、恐吓、伤害性、庸俗或其它侵害他人身份权的信息；
        </p>
        <p>
          （5）严禁发布虚假、不完整、不准确、欺骗性的资料，否则一经发现，本平台有权停止对该用户的服务。
        </p>
        <h2>四、免责条款</h2>
        <p>
          1、您理解并同意：鉴于网络服务的特殊性或国家政策、行业规定的调整、变化等，运营方有权根据本服务的整体运营情况或相关运营规范、规则等，变更、中止或终止部分或全部的服务。
        </p>
        <p>
          2、您理解并同意：为了向您提供更完善的服务，运营方有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给您造成损失的，您同意放弃追究运营方的责任。
        </p>
        <p>
          3、您理解并同意：运营方的服务是按照现有技术和条件所能达到的现状提供的。运营方会尽最大努力向您提供服务，确保服务的连贯性和安全性；但运营方不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险。
        </p>
        <h2>五、知识产权</h2>
        <p>
          1、运营方在本服务中提供的信息内容的知识产权均归运营方所有，依法属于他人所有的除外。未经运营方书面许可，您不得以任何形式进行使用或创造相关衍生作品。
        </p>
        <p>
          2、您仅拥有依照本协议约定合法使用本服务或相关技术接口的权利，与本服务相关的技术接口相关的全部权利归运营方所有。
        </p>
        <h2>六、其它</h2>
        <p>
          1、本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。
        </p>
        <p>
          2、若您和运营方之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showAgreement = false">确定我已阅读</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  login,
  verifycode,
  loginverifycode,
  passVerifyCode,
  updatePassword,
  capthImageCode,
} from '@/api/login'
import { setCookie } from '@/utils/cookies'
import to from 'await-to'
import checkcodeImg from '@/assets/login/checkcode.png'
export default {
  name: 'Login',
  data() {
    return {
      checkcodeImg,
      disabled: false,
      time: 60,
      btntxt: '发送验证码',
      disabled2: false,
      time2: 60,
      btntxt2: '发送验证码',
      Isshow: true,
      IsForget: false,
      activeName: 'first',
      agreed: false,
      showPrivacy: false,
      showAgreement: false,
      input1: '',
      input2: '',
      captchaCode: '',
      captchaImage: '',
      captchaKey: '',
      input3: '',
      input4: '',
      forgetPhone: '',
      forgetCode: '',
      newPassword: '',
      confirmNewPassword: '',
    }
  },
  created() {
    this.handleGetVerifyImgCode()
  },
  methods: {
    //获取验证图片和code
    async handleGetVerifyImgCode() {
      const [res, err] = await to(capthImageCode({}))
      if (err) return this.$message.warning(err.msg)
      this.captchaImage = res.data.captchaImage
      this.captchaKey = res.data.captchaKey
    },
    // 刷新验证码
    refreshCaptcha() {
      this.handleGetVerifyImgCode()
    },
    loginbox() {
      this.Isshow = true
      this.IsForget = false
    },
    forgetbox() {
      this.Isshow = false
      this.IsForget = true
    },
    checkAgreement() {
      if (!this.agreed) {
        this.$message({
          message: '请先阅读并同意《隐私协议》和《使用协议》',
          type: 'warning',
        })
        return false
      }
      return true
    },
    async loginAccount() {
      if (!this.checkAgreement()) return
      if (this.input1 == '') {
        this.$message({
          message: '请填写帐号',
          type: 'warning',
        })
        return false
      }
      if (this.input2 == '') {
        this.$message({
          message: '请填写密码',
          type: 'warning',
        })
        return false
      }
      if (this.captchaCode == '') {
        this.$message({
          message: '请输入验证码',
          type: 'warning',
        })
        return false
      }
      const [res, err] = await to(
        login({
          account: this.input1,
          password: this.input2,
          adminClient: true,
          captchaCode: this.captchaCode,
          captchaKey: this.captchaKey,
        }),
      )
      if (err) return this.$message.error(err.msg)
      setCookie('myToken', res.data.token)
      setCookie('userInfo', res.data)
      setCookie('headPic', res.data.headPic)
      setCookie('nickName', res.data.nickName)
      setCookie('userName', res.data.userName)
      setCookie('email', res.data.email)
      setCookie('sex', res.data.sex)
      setCookie('phone', res.data.phone)
      this.$message({
        message: '登录成功',
        type: 'success',
      })
      setTimeout(() => {
        this.$router.push('/dashbord')
      }, 1000)
    },
    // 获取登录验证码
    verifyCode() {
      if (this.input3 == '') {
        this.$message({
          message: '请填写11位手机号',
          type: 'warning',
        })
        return false
      }
      verifycode({
        phone: this.input3,
      }).then(res => {
        if (res.msg == 'success') {
          this.$message({
            message: '获取验证码成功，请在手机上查看',
            type: 'success',
          })
          this.time = 60
          this.timer()
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
          })
        }
      })
    },
    // 倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true
        this.time--
        this.btntxt = this.time + '秒'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '发送验证码'
        this.disabled = false
      }
    },
    // 手机验证码登录
    async loginVerifyCode() {
      if (!this.checkAgreement()) return
      if (this.input3 == '') {
        this.$message({
          message: '请填写手机号',
          type: 'warning',
        })
        return false
      }
      if (this.input4 == '') {
        this.$message({
          message: '请填写验证码',
          type: 'warning',
        })
        return false
      }
      const [res, err] = await to(loginverifycode({ phone: this.input3, verifyCode: this.input4 }))
      if (err) return this.$message.warning(err.msg)
      setCookie('myToken', res.data.token)
      setCookie('userInfo', res.data)
      setCookie('headPic', res.data.headPic)
      setCookie('nickName', res.data.nickName)
      setCookie('userName', res.data.userName)
      setCookie('email', res.data.email)
      setCookie('sex', res.data.sex)
      setCookie('phone', res.data.phone)
      this.$message({
        message: '登录成功',
        type: 'success',
      })
      setTimeout(() => {
        this.$router.push('/dashbord')
      }, 1000)
    },
    // 忘记密码-发送验证码
    sendForgetCode() {
      if (this.forgetPhone == '') {
        this.$message({
          message: '请填写11位手机号',
          type: 'warning',
        })
        return
      }
      passVerifyCode({
        phone: this.forgetPhone,
      }).then(res => {
        if (res.msg == 'success') {
          this.$message({
            message: '获取验证码成功，请在手机上查看',
            type: 'success',
          })
          this.time2 = 60
          this.forgetTimer()
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
          })
        }
      })
    },
    // 忘记密码倒计时
    forgetTimer() {
      if (this.time2 > 0) {
        this.disabled2 = true
        this.time2--
        this.btntxt2 = this.time2 + '秒'
        setTimeout(this.forgetTimer, 1000)
      } else {
        this.time2 = 0
        this.btntxt2 = '发送验证码'
        this.disabled2 = false
      }
    },
    // 重置密码
    async resetPassword() {
      if (this.forgetPhone == '') {
        this.$message({
          message: '请输入手机号',
          type: 'warning',
        })
        return
      }
      if (this.forgetCode == '') {
        this.$message({
          message: '请输入验证码',
          type: 'warning',
        })
        return
      }
      if (this.newPassword == '') {
        this.$message({
          message: '请输入新密码',
          type: 'warning',
        })
        return
      }
      if (this.confirmNewPassword == '') {
        this.$message({
          message: '请再次输入新密码',
          type: 'warning',
        })
        return
      }
      if (this.newPassword != this.confirmNewPassword) {
        this.$message({
          message: '两次密码不一致，请确认！',
          type: 'warning',
        })
        return
      }
      const [, err] = await to(
        updatePassword({
          phone: this.forgetPhone,
          verifyCode: this.forgetCode,
          password: this.newPassword,
          confirmPassword: this.confirmNewPassword,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.IsForget = false
      this.Isshow = true
      this.$message({
        message: '密码重置成功，请登录',
        type: 'success',
      })
    },
  },
}
</script>
<style scoped>
.login {
  width: 100%;
  height: 100vh;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
}
.login-box,
.regist-box {
  width: 460px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(126, 126, 126, 0.12);
  border-radius: 8px;
  padding-bottom: 30px;
}
/* tabs 样式 */
.login-box >>> .el-tabs {
  width: 340px;
  margin: 25px 60px 0;
}
.login-box >>> .el-tabs__header {
  margin: 0;
  padding: 0;
  visibility: visible;
}
.login-box >>> .el-tabs__nav-wrap {
  overflow: visible;
}
.login-box >>> .el-tabs__nav {
  width: 100%;
  display: flex;
}
.login-box >>> .el-tabs__item {
  width: 170px;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  font-weight: 800;
  color: #333333;
  padding: 0;
  text-align: center;
  flex: 1;
}
.login-box >>> .el-tabs__item.is-active {
  color: #ff7b33;
}
.login-box >>> .el-tabs__active-bar {
  background-color: #ff7b33;
  height: 3px;
}
.login-box >>> .el-input {
  background-color: transparent;
}
.login-box >>> .el-input__inner {
  height: 60px;
  line-height: 60px;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #dcdfe6;
  background-color: transparent;
}
.login-box >>> .el-input-group__prepend {
  background-color: #fff;
  border-top: 0;
  border-left: 0;
  border-radius: 0;
  box-shadow: none;
}
/* 图形验证码行 */
.codeVerify {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.codeVerify .el-input {
  flex: 1;
  margin-right: 15px;
}
.codeVerify >>> .el-input {
  background-color: transparent;
}
.codeVerify >>> .el-input__inner {
  height: 60px;
  line-height: 60px;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #dcdfe6;
  background-color: transparent;
}
.codeVerify >>> .el-input__prefix {
  left: 0;
  color: #c0c4cc;
  background-color: transparent;
}
.captcha-img {
  width: 120px;
  height: 45px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  object-fit: cover;
  margin-bottom: 0;
}
/* 短信验证码行 */
.flex-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-item .el-input {
  flex: 1;
  margin-right: 10px;
}
.yzmBtn {
  width: 140px;
  border-radius: 20px;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  padding: 0;
}
/* 按钮行 */
.newBtn {
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
  padding: 0;
}
.newBtn span {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #ff7b33;
}
.loginBtn {
  width: 340px;
  height: 44px;
  line-height: 44px;
  background: #ff7b33;
  border-radius: 22px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin: 24px auto 0;
  cursor: pointer;
}
/* 其他登录方式 */
.other-item {
  margin: 24px auto 0;
  width: 340px;
}
.icon-item {
  display: flex;
  justify-content: center;
}
.wechat-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.wechat-icon img {
  display: block;
  width: 24px;
  height: 24px;
}
/* 协议条款 */
.agreement {
  width: 340px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.agreement >>> .el-checkbox {
  margin-right: 6px;
}
.agreement >>> .el-checkbox__inner {
  width: 14px;
  height: 14px;
}
.agreement >>> .el-checkbox__inner::after {
  left: 3px;
  top: 0;
}
.agreement-text {
  font-size: 12px;
  color: #999999;
  line-height: 1.6;
}
.agreement-link {
  color: #ff7b33;
  cursor: pointer;
}
.agreement-link:hover {
  text-decoration: underline;
}
/* 协议弹窗内容 */
.agreement-content {
  max-height: 450px;
  overflow-y: auto;
  padding-right: 10px;
}
.agreement-content h1 {
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
}
.agreement-content h2 {
  font-size: 14px;
  font-weight: 700;
  margin: 15px 0 8px;
}
.agreement-content p {
  text-indent: 2em;
  font-size: 13px;
  line-height: 1.8;
  margin: 5px 0;
  color: #333;
}
/* 忘记密码面板 */
.title {
  display: block;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #333333;
  margin-top: 30px;
  margin-bottom: 20px;
}
.regist-box >>> .el-input {
  width: 340px;
  margin: 0 auto;
  display: flex;
}
.regist-box >>> .el-input-group__prepend {
  border: 0;
  border-bottom: 1px solid #dcdfe6;
  background-color: #fff;
  color: #333333;
  line-height: 60px;
}
.regist-box >>> .el-input__inner {
  height: 60px;
  line-height: 60px;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #dcdfe6;
}
.regist-box .flex-item {
  width: 340px;
  margin: 0 auto;
}
.regist-box .loginBtn {
  margin-top: 24px;
}
.regist-box .forgetPhone {
  align-items: center;
}

.tip {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: #ff7b33;
  cursor: pointer;
}
/* 底部版权 */
.copyright {
  font-size: 12px;
  color: #999999;
  padding: 20px 0;
  text-align: center;
}
</style>
